/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A file an account stores that people can act on: an asset or a document
 */
export type TStoredFile = {
    /**
     * Documents only: kept when the project's documents are deleted
     */
    keep: boolean | null;
    project_archived: boolean;
    project_name: string;
    project_id: string;
    created_at: string;
    size_bytes: number;
    type: string;
    name: string;
    id: string;
    kind: TStoredFile.kind;
};
export namespace TStoredFile {
    export enum kind {
        ASSET = 'asset',
        DOCUMENT = 'document',
    }
}

